export function useIsStandardText() {
  const params = useLawRouteParams()
  const { restrictedNsLaw } = useRuntimeConfig().public.licenses

  return computed(() => params.value.lawId?.toLowerCase().includes(restrictedNsLaw) ?? false)
}
